import { useDebounce } from "@uidotdev/usehooks";
import "moment/locale/cs";
import { useState } from "react";
import { useSelector } from "react-redux";
import useSWR from "swr";
import UserCard from "./UserCard";
import { AlcDrawer, DrawerTitle } from "./ui/drawer";
import { Input } from "./ui/input";

const fetcher = (token) => async (url) => {
  const res = await fetch(url, { headers: { Authorization: token } });

  return res.json();
};

export default function AddFriendDrawer({
  children,
}: {
  children: React.ReactNode;
}) {
  const userState = useSelector((state: any) => state.user);

  const [searchedName, setSearchedName] = useState("");

  const debouncedSearchedName = useDebounce(searchedName, 500);

  const shouldFetch = debouncedSearchedName.length >= 3;

  const { data, error, isLoading } = useSWR(
    shouldFetch
      ? `${
          process.env.REACT_APP_API_URL
        }/users/friends/search/${encodeURIComponent(debouncedSearchedName)}`
      : null,
    fetcher(userState.token),
    {}
  );

  return (
    <AlcDrawer
      trigger={children}
      header={
        <>
          <DrawerTitle>Přidání přátel</DrawerTitle>
        </>
      }
      asChild
    >
      <div className="p-4 pt-2">
        <Input
          type="text"
          placeholder="Zadejte tag uživatele"
          value={searchedName}
          onChange={(e) => setSearchedName(e.target.value)}
        />
      </div>
      <div
        style={{
          textAlign: "center",
          color: "hsl(var(--muted-foreground))",
        }}
      >
        {isLoading && <>Načítání...</>}
        {!isLoading && error && shouldFetch && <>Chyba při načítání</>}
        {!isLoading && !error && (data ?? []).length === 0 && shouldFetch && (
          <>Žádní uživatelé s tímto jménem</>
        )}
      </div>
      {!isLoading && !error && (data ?? []).length > 0 && (
        <div className="flex flex-col gap-4">
          {(data ?? []).map((user) => (
            <UserCard userId={user.userId} key={user.userId} />
          ))}
        </div>
      )}
    </AlcDrawer>
  );
}
